import { render, staticRenderFns } from "./BranchAreaReportComponent.vue?vue&type=template&id=8958e230&scoped=true"
import script from "./BranchAreaReportComponent.vue?vue&type=script&lang=js"
export * from "./BranchAreaReportComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchAreaReportComponent.vue?vue&type=style&index=0&id=8958e230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958e230",
  null
  
)

export default component.exports